import styled from "styled-components";

export const MuiNotesToolTipWrapper = styled.div`
  .tooltip-content {
    overflow-x: hidden;
  }
  .error-icon {
    display: flex;
    flex-direction: row;
  }
`;
